module.exports = __webpack_public_path__ + "static/media/photo-4.c7a96cc1.jpg";